import gql from 'graphql-tag';
import { SECRETARY_OF_STATE_LAST_REPORT_FRAGMENT } from './fragments/secretaryOfStateReportFragment';

export const GET_LAST_SECRETARY_OF_STATE_REPORT_FOR_ACCOUNT = gql`
  query LastSecretaryOfStateReportForAccount($input: LastSecretaryOfStateReportForAccountInput!) {
    cobaltIntelligence {
      result: lastSecretaryOfStateReportForAccount(input: $input) {
        error
        success
        entity {
          ...SecretaryOfStateLastReportViewModel
        }
      }
    }
  }
  ${SECRETARY_OF_STATE_LAST_REPORT_FRAGMENT}
`;
